import * as yup from 'yup';
import { COMPANY_NAME_INVALID, COMPANY_NAME_REQUIRED, COMPANY_ADDRESS_REQUIRED, COMPANY_ADDRESS_INVALID, COMPANY_ADDRESS_LINE_2_INVALID, ZIPCODE_REQUIRED, PHONE_REQUIRED, PHONE_DUPLICATE, } from '../../constants/field-error-messages';
import { COMPANY_NAME_REGEX, ADDRESS_REGEX, ZIPCODE_REGEX, PHONE_REGEX, } from '../../constants/regex';
var checkPhoneDuplications = function (value, _a) {
    var from = _a.from, path = _a.path;
    var valueIndex = parseInt((path === null || path === void 0 ? void 0 : path.split('[')[1].split(']')[0]) || '', 10);
    var formValues = from === null || from === void 0 ? void 0 : from[1].value;
    return (!value ||
        (formValues.companyPhone !== value &&
            !formValues.alternatePhones.some(function (_a, index) {
                var number = _a.number;
                return value === number && valueIndex !== index;
            })));
};
export var validationSchema = yup.object().shape({
    companyName: yup
        .string()
        .required(COMPANY_NAME_REQUIRED.message)
        .trim()
        .matches(COMPANY_NAME_REGEX, COMPANY_NAME_INVALID.message),
    businessType: yup.string(),
    address: yup
        .string()
        .required(COMPANY_ADDRESS_REQUIRED.message)
        .trim()
        .matches(ADDRESS_REGEX, COMPANY_ADDRESS_INVALID.message),
    addressLine2: yup
        .string()
        .matches(ADDRESS_REGEX, {
        message: COMPANY_ADDRESS_LINE_2_INVALID.message,
        excludeEmptyString: true,
    })
        .trim(),
    companyPhone: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, PHONE_REQUIRED.message),
    zipCode: yup
        .string()
        .required(ZIPCODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, ZIPCODE_REQUIRED.message),
    cityState: yup.string(),
    alternatePhones: yup.array().of(yup.object().shape({
        number: yup
            .string()
            .matches(PHONE_REGEX, {
            message: PHONE_REQUIRED.message,
            excludeEmptyString: true,
        })
            .test('is the phone number unique', PHONE_DUPLICATE.message, checkPhoneDuplications),
    })),
});
